// src/App.jsx
import React, { useState } from "react";
import "./weather.css";
import sunImg from "./images/sun.jpg";
 

const apiKey = "4a7cdadf979ba1e41c919a05518d93bc";

function App() {
  const [city, setCity] = useState("");
  const [weatherData, setWeatherData] = useState(null);
  const [darkMode, setDarkMode] = useState(false);
  const [error, setError] = useState("");

  const getWeather = async () => {
    try {
      setError("");
      const res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`
      );
      if (!res.ok) throw new Error("City not found");
      const data = await res.json();
      setWeatherData(data);
    } catch (err) {
      setWeatherData(null);
      setError(err.message);
    }
  };

  return (
    <div className={`app-container ${darkMode ? "dark-mode" : ""}`}>
      <nav className="navbar">
        <div className="logo">☁️ WeatherMate</div>
        <ul className="nav-links">
          <li><a href="#home">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#howtouse">How to Use</a></li>
        </ul>
        <label className="mode-toggle">
          <input
            type="checkbox"
            onChange={() => setDarkMode(!darkMode)}
            checked={darkMode}
          />
          <span className="slider"></span>
        </label>
      </nav>

      <div id="home" className="php">
        <img src={sunImg} alt="Sun" />
        <div className="form-container">
          <input className="name"
            type="text"
            placeholder="Enter city name"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
          <button className="submit-btn" onClick={getWeather}>
            Get Weather
          </button>
        </div>

        <div id="weatherResult">
          {error && <p style={{ color: "red" }}>{error}</p>}
          {weatherData && (
            <>
              <h2>
                {weatherData.name}, {weatherData.sys.country}
              </h2>
              <p>🌡️ Temperature: {weatherData.main.temp} °C</p>
              <p>☁️ Weather: {weatherData.weather[0].description}</p>
              <p>💨 Wind: {weatherData.wind.speed} m/s</p>
            </>
          )}
        </div>
      </div>

      <section id="about" className="info-section">
        <h2>About WeatherMate</h2>
        <p>
          WeatherMate is a sleek, modern weather application that helps you stay
          updated with real-time weather data in your city.
        </p>
      </section>

      <section id="howtouse" className="info-section">
        <h2>How to Use</h2>
        <ul>
          <li>Enter your city name in the input box.</li>
          <li>Click "Search" to fetch weather.</li>
          <li>View temperature, humidity, and wind instantly.</li>
        </ul>
      </section>

      <footer className="footer">
        <h5 className="last">&copy; 2025 WeatherMate. All rights reserved.</h5>
        <p> Made with ❤️ by shoaib </p>
      </footer>
    </div>
  );
}

export default App;
